<div class="ub ub-ae">
  <a-select
    :multiple="false"
    placeholder="全部项目"
    :value="projectId"
    :allowClear="allowClear"
    option-filter-prop="title"
    :filter-option="false"
    :not-found-content="fetching ? undefined : null"
    show-search
    @search="initData"
    style="width:300px;"
    @change="handleChange">
    <a-spin v-if="fetching" slot="notFoundContent" size="small" />
    <a-select-option v-for="item in projectList" :key="item.id" :title="item.name" :value="item.id">
      {{ item.name }}
    </a-select-option>
  </a-select>
  <a-button type="primary" style="margin-left:10px;" @click="jumpFn">查询</a-button>
</div>